module.exports = __webpack_public_path__ + "images/import_vcard.svg";